// Tracks which entry point brought the customer to the checkout page.
//   'choose' → nav/footer/hero ORDER NOW, popups, generic CTAs:
//              show the pack selector on checkout so the customer picks a pack.
//   'buy'    → Buy Now from the product section (pack already chosen on the
//              home page): classic quantity-only view, no selector.
// Stored in sessionStorage so each tab keeps its own flow.
export const setCheckoutFlow = (flow) => {
  try { sessionStorage.setItem('osf_checkout_flow', flow); } catch (_) {}
};

export const getCheckoutFlow = () => {
  try { return sessionStorage.getItem('osf_checkout_flow') || 'choose'; }
  catch (_) { return 'choose'; }
};
